<template>
    <div class="foot-nav">
        <div class="navBox marg0">
            <div class="nav">
                <template v-for="(item,index) in menus">
                    <div class="nav-item" v-if="item.isDisplay">
                        <template v-if="index==2">
                            <div class="mapp">
                                <router-link active-class="active" :to="{name:item.name, params: { mchId: $route.params.mchId }}">
                                    <div v-bind:class="[iconfont, item.icon]"></div>
                                    <div>{{item.title}}</div>
                                </router-link>
                            </div>
                        </template>
                        <template v-else>
                            <router-link active-class="active" :to="{name:item.name, params: { mchId: $route.params.mchId }}">
                                <div v-bind:class="[iconfont, item.icon]"></div>
                                <div>{{item.title}}</div>
                            </router-link>
                        </template>
                    </div>
                </template>
                
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "footNav",
    components: {

    },
    data() {
        return {
            iconfont: 'iconfont',
            menus: []
        }
    },
    created() {
        var that = this;
        that.init();
    },
    mounted() {
        
    },
    methods: {
        init() {
            var that = this;
            that.menus = that.$navigation.Router.getByParentId(0);
            console.log('menus',that.menus);
        }
    }
}
</script>

<style scoped lang="scss">
    .foot-nav {
        margin-top: 2.5rem;
        .active {
            color: #5A93FF !important;
        }

        .navBox {
            position: fixed;
            bottom: 0;
            width: 100%;
            z-index: 99;

            .nav {
                position: relative;
                border: 0.01rem solid #f3f3f3;
                background-color: white;
                display: flex;
            }

            .nav-item {
                text-align: center;
                //line-height: 20px;
                padding: 10px 0 6px 0;
                width: 20%;

                .iconfont {
                    font-size: 20px;
                    margin-bottom: 2px;
                }

                .mapp {
                    position: absolute;
                    bottom: -13px;
                    background: #FFF;
                    width: 20%;
                    border-radius: 50%;
                    padding: 20px 0;

                    .iconfont {
                        font-size: 24px;
                        margin-bottom: 3px;
                    }
                }
            }

            a {
                color: #696969;
                font-size: 12px;
                text-decoration: auto;
            }
        }
    }
    
</style>